<template>
    <div data-component="stratmk.nav-menu.v12020" class="nav-menu max">
        <v-layout justify-center align-center py-8>
            <v-layout row wrap justify-center align-center>
                <v-card 
                    flat
                    color="transparent" v-for="(n, i) in navOpt" :key="i" class="nav-item mx-8" :to="{name: n.to}" @click="closeMenu(n.to)" @mouseover.native="previewRoute(n.to)">
                    <v-card-title class="n-title font-weight-black justify-center pb-0 dolo" style="letter-spacing: -0px;">{{n.title}}</v-card-title>
                    <v-card-text class="n-subtitle text-center pt-1 roboto font-weight-light text-uppercase">{{n.subtitle}}</v-card-text>
                    <v-card-text class="">
                        <v-layout justify-center>
                            <v-card flat height="1" width="30px" color="dolo-b"></v-card>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-layout>
        </v-layout>
    </div>
</template>

<script>
export default {
    components: {},
    props: {},
    data: () => {
        return {
            navOpt: [
                {
                    title: 'Strategery.',
                    subtitle: 'What is it?',
                    to: 'home'
                },
                {
                    title: 'Investor Relations.',
                    subtitle: 'Join the next big thing.',
                    to: 'investor_relations'
                },
                /* {
                    title: 'Overview.',
                    subtitle: 'The Cheat Sheet.',
                    to: 'overview'
                }, */
            ]
        }
    },
     methods: {
        closeMenu(r){
            this.$emit('closeMenu', r)
            this.$emit('homeSection')
            //eslint-disable-next-line
            //console.log('nav-menu.methods.closeMenu -- ' +r)
        },
        previewRoute(r){
            this.$emit('previewRoute', r)
            //eslint-disable-next-line
            //console.log('nav-menu.methods.previewRoute -- emitted '+r)
        }
    }
}
</script>

<style lang="scss" scoped>

    $hover-color: #2BCDC9;

    .nav-menu {
        position: fixed;
        width: 100%;
        top: 0;
        left: 0;

        .nav-item {
            .n-title {
                color: white;
                letter-spacing: -55px;
                font-size: 30px;
            }
            .n-subtitle {
                color: white;
                font-size: 1.275rem
            }

            &:hover {
                .n-title {
                    color: $hover-color
                }
            }
        }
    }

    .tablet {
        .nav-menu {
            position: fixed;
            height: 100vh;
            width: 100%;
            top: 0;
            left: 0;
            padding-top: 8%;

            .nav-item {
                .n-title {
                    color: white;
                    letter-spacing: -55px;
                    font-size: 18px;
                }
                .n-subtitle {
                    font-size: 12px;
                    display: none;
                }

                &:hover {
                    .n-title {
                        color: $hover-color
                    }
                }
            }
        }
    }
</style>